"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFreshchat = _interopRequireDefault(require("react-freshchat"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Freshchat(_ref) {
  var user = _ref.user,
    token = _ref.token,
    enabled = _ref.enabled,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'es' : _ref$locale;
  var onInit = (0, _react.useCallback)(function (widget) {
    var _a;
    widget.setConfig({
      headerProperty: {
        direction: 'ltr'
      }
    });
    if (user) {
      widget.user.setProperties({
        external_id: user.id,
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        phone: (_a = user.phone) !== null && _a !== void 0 ? _a : ''
      });
    }
  }, [user]);
  if (token && enabled && user) {
    return /*#__PURE__*/_react["default"].createElement(_reactFreshchat["default"], {
      token: token,
      locale: locale,
      external_id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      onInit: onInit
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Freshchat);